import React, { useMemo } from 'react'
import { Button, Typography } from 'antd'
import { ChevronDown, ChevronRight } from 'lucide-react'
import { SupplierOrderItemList } from './PurchaseOrderDrawer'
import { useFFEStore } from '../../store/ffeStore'

const { Text } = Typography

interface Props {
  supplier: string
  items: SupplierOrderItemList
  isCollapsed: boolean
  onToggleCollapse: () => void
}

export const SupplierOrderHeader: React.FC<Props> = ({
  supplier,
  items,
  isCollapsed,
  onToggleCollapse
}) => {
  const suppliers = useFFEStore((state) => state.suppliers)
  // Count unordered items
  const unorderedCount = useMemo(() => {
    const itemsCount = items.filter(
      (item) => item.type === 'lineItem' && item.status !== 'ordered'
    ).length
    const materialsCount = items.filter(
      (material) =>
        material.type === 'material' && material.status !== 'ordered'
    ).length
    return itemsCount + materialsCount
  }, [items])

  const supplierName = useMemo(() => {
    const tempSup = suppliers.find((s) => s._id === supplier)
    return tempSup ? tempSup.name : ''
  }, [suppliers, supplier])

  return (
    <div
      onClick={onToggleCollapse}
      className="cursor-pointer flex items-center gap-4 p-4 bg-gray-50 rounded-lg"
    >
      <Button
        type="text"
        icon={
          isCollapsed ? (
            <ChevronRight className="h-4 w-4" />
          ) : (
            <ChevronDown className="h-4 w-4" />
          )
        }
      />

      <div className="flex-1">
        <Text strong>{supplierName}</Text>
      </div>

      {unorderedCount > 0 && (
        <div className="bg-orange-100 text-orange-700 px-2 py-1 rounded text-sm">
          {unorderedCount} unordered {unorderedCount === 1 ? 'item' : 'items'}
        </div>
      )}
    </div>
  )
}
